const millisInDay = 24 * 60 * 60 * 1000;

export const getCookie = (name: string): string => {
  if (typeof document === 'undefined') {
    return '';
  }

  const match = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`) || [];

  return match[2];
};

export const setCookie = (name, value, days) => {
  const d = new Date();
  d.setTime(d.getTime() + millisInDay * days);
  document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`;
};
